import React, { useContext } from 'react';
import visible from '../../images/visible.svg';
import { EditorContext } from './EditorContext';

const EntryCaption: React.FC = () => {
  const { state, dispatch } = useContext(EditorContext);
  const { context } = state.input;

  return (
    <>
      <div className="flex justify-between items-center mt3 mb3">
        <p className="flex items-center f8 serif i mv0">
          <img
            src={visible}
            style={{ width: 18, height: 16 }}
            className="db mr2"
            alt="Visible to everyone"
          />
          Everyone can see this note
        </p>
      </div>

      <textarea
        className="bg-near-white w-100 sans-serif flex-auto pa3 lh-copy bn br2 mb4"
        style={{ resize: 'none', minHeight: 160 }}
        name="Caption"
        value={context || ''}
        placeholder="Write a short caption to appear with these data points..."
        onChange={(event: React.SyntheticEvent) => {
          const target = event.target as HTMLTextAreaElement;
          dispatch({ type: 'updateCaption', value: target.value });
        }}
        data-testid="quala-editor-Caption-input"
      />
    </>
  );
};

export default EntryCaption;
